import axios from '@/plugins/axios';

export async function search(filters){
    return await axios.post('organizations/find-in-cl', {filters});
}

export async function debtResultsConnection(workspaceId, organizationId){
    return await axios.post(`work-spaces/${workspaceId}/${organizationId}/debt-results/connection`);
}

export async function debtResultsConnectionRetry(workspaceId, organizationId){
    return await axios.post(`work-spaces/${workspaceId}/${organizationId}/debt-results/connection/retry`);
}

export async function debtResultsConnectionDelete(workspaceId, organizationId, debtConnectionId){
    return await axios.delete(`work-spaces/${workspaceId}/organizations/${organizationId}/debt-result-connections/${debtConnectionId}`);
}

export async function attach(userId, cred){
    return await axios.post(`users/${userId}/organizations`, cred);
}

export async function userOrganizations(userId){
    return await axios.get(`users/${userId}/organizations`);
}

export async function workspaceOrganizations(workspaceId, params = {}){
    return await axios.get(`work-spaces/${workspaceId}/organizations`, {params});
}
export async function remove(workspaceId, organizationId){
    return await axios.delete(`work-spaces/${workspaceId}/organizations/${organizationId}`);
}
export async function workspaceOrganizationShow(workspaceId, organizationId){
    return await axios.get(`work-spaces/${workspaceId}/organizations/${organizationId}`);
}

export async function workspaceOrganizationCheckout(workspaceId, organizationId){
    return await axios.post(`work-spaces/${workspaceId}/organizations/${organizationId}/checkout`);
}

export async function workspaceAddOrganization(workspaceId, cred){
    return await axios.post(`work-spaces/${workspaceId}/organizations`, cred);
}

export async function exportDebtResultMessages(workspaceId, organizationId, options = {}){
    return await axios.get(`work-spaces/${workspaceId}/organizations/${organizationId}/export-debt-result-messages`, options);
}

export async function exportDebtResultMessageShow(workspaceId, organizationId, exportDebtResultMessageId){
    return await axios.get(`work-spaces/${workspaceId}/organizations/${organizationId}/export-debt-result-messages/${exportDebtResultMessageId}`);
}

export async function exportDebtResultMessageReport(workspaceId, organizationId, options = {}){
    return await axios.get(`work-spaces/${workspaceId}/organizations/${organizationId}/export-debt-result-messages/report/download`, options);
}

export async function importDebtResponses(workspaceId, organizationId, data){
    return await axios.post(`work-spaces/${workspaceId}/${organizationId}/debt-results/import`, data);
}
export async function importDebtResponsesCounter(workspaceId, organizationId){
    return await axios.get(`work-spaces/${workspaceId}/${organizationId}/debt-results/import-counter`);
}
export async function socialDebtorsIndex(workspaceId, organizationId, options = {}){
    return await axios.get(`work-spaces/${workspaceId}/organizations/${organizationId}/house-person-debtors`, options);
}

export async function socialDebtorsStore(workspaceId, organizationId, data){
    return await axios.post(`work-spaces/${workspaceId}/organizations/${organizationId}/house-person-debtors`, data);
}

export async function socialDebtorsUpdate(workspaceId, organizationId, housePersonDebtorId, data){
    return await axios.put(`work-spaces/${workspaceId}/organizations/${organizationId}/house-person-debtors/${housePersonDebtorId}`, data);
}

export async function socialDebtorsDelete(workspaceId, organizationId, housePersonDebtorId){
    return await axios.delete(`work-spaces/${workspaceId}/organizations/${organizationId}/house-person-debtors/${housePersonDebtorId}`);
}

export async function socialDebtorsShow(workspaceId, organizationId, housePersonDebtorId){
    return await axios.get(`work-spaces/${workspaceId}/organizations/${organizationId}/house-person-debtors/${housePersonDebtorId}`);
}

export async function houseObjectsIndex(workspaceId, organizationId, params = {}){
    return await axios.get(`work-spaces/${workspaceId}/organizations/${organizationId}/house-address-objects`, { params });
}

export async function houseObjectPremises(workspaceId, organizationId, fias, params = {}){
    return await axios.get(`work-spaces/${workspaceId}/organizations/${organizationId}/house-address-objects/${fias}/premises`, { params });
}

export async function houseObjectPremiseStore(workspaceId, organizationId, house_address_object_id, premise){
    return await axios.post(`work-spaces/${workspaceId}/organizations/${organizationId}/house-address-objects/${house_address_object_id}/premises`, 
                            {housingFundObject_addressDetails : premise});
}

export async function organizationExecutorIndex(workspaceId, organizationId){
    return await axios.get(`work-spaces/${workspaceId}/organizations/${organizationId}/executors`);
}

export async function organizationExecutorStore(workspaceId, organizationId, data){
    return await axios.post(`work-spaces/${workspaceId}/organizations/${organizationId}/executors`, data);
}

export async function organizationExecutorUpdate(workspaceId, organizationId, executorId, data){
    return await axios.put(`work-spaces/${workspaceId}/organizations/${organizationId}/executors/${executorId}`, data);
}

export async function organizationNotifications(workspaceId, organizationId, params){
    return await axios.get(`work-spaces/${workspaceId}/organizations/${organizationId}/notifications`, {params});
}

export async function socialWidget(workspaceId, organizationId){
    return await axios.get(`work-spaces/${workspaceId}/organizations/${organizationId}/widgets/social`);
}

export async function organizationImportErrorCode(workspaceId, organizationId, errorCode = null){
    return await axios.get(`work-spaces/${workspaceId}/organizations/${organizationId}/import-debt-error`, {params: {error_code: errorCode}});
}

export async function organizationFiasHouses(workspaceId, organizationId, params = {}){
    return await axios.get(`work-spaces/${workspaceId}/organizations/${organizationId}/fias-houses`, {params});
}

export async function organizationFiasHouseRemove(workspaceId, organizationId, fiasHouseId){
    return await axios.delete(`work-spaces/${workspaceId}/organizations/${organizationId}/fias-houses/${fiasHouseId}`);
}
export async function organizationFiasHouseSave(workspaceId, organizationId, data){
    return await axios.post(`work-spaces/${workspaceId}/organizations/${organizationId}/fias-houses`, data);
}
export async function organizationFiasHouseUpdate(workspaceId, organizationId, fiasHouseId){
    return await axios.put(`work-spaces/${workspaceId}/organizations/${organizationId}/fias-houses/${fiasHouseId}`);
}
export async function fiasHousesSearch(suggest){
    return await axios.get(`fias-houses/search`, {params: {suggest}});
}
export async function enableDebtImportAutomat(work_space, organization, data){
    return await axios.post(`work-spaces/${work_space}/organizations/${organization}/debt-import-automats`, data);
}
export async function disableDebtImportAutomat(work_space, organization){
    return await axios.delete(`work-spaces/${work_space}/organizations/${organization}/debt-import-automats`);
}